import { Link } from 'react-router-dom';

interface Video {
  title: string;
  author: string;
  views: string;
  duration: string;
  imageUrl: string;
}

interface HotVideosProps {
  title: string;
  subtitle?: string;
  videos: Video[];
  viewAllLink?: string;
}

export default function HotVideos({ title, subtitle, videos, viewAllLink }: HotVideosProps) {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {title}
            </h2>
            {subtitle && <p className="text-sm text-foreground-600">{subtitle}</p>}
          </div>
          {viewAllLink && (
            <Link to={viewAllLink} className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {videos.map((video, index) => (
            <Link
              key={index}
              to={`/category/搞笑`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[9/16] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={video.imageUrl}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-1.5 py-0.5 rounded">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-1.5 py-0.5 rounded">
                  热播
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{video.author}</span>
                <span>·</span>
                <span>{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}